import Vue from 'vue'

Vue.filter('formatNumber', function (value, separator = '.') {
  return value.toLocaleString() // displaying other groupings/separators is possible, look at the docs
})
